export const InsightKeyTakeaway = ({ paragraphs = [], testIdPrefix = "insight-key-takeaway" }) => {
  if (!paragraphs.length) return null;

  return (
    <section
      className="rounded-[2rem] border border-emerald-200/80 bg-[linear-gradient(135deg,rgba(236,244,239,0.96)_0%,rgba(247,250,248,0.96)_100%)] px-7 py-8 shadow-[0_18px_48px_rgba(28,25,23,0.05)] sm:px-10"
      data-testid={`${testIdPrefix}-section`}
    >
      <div className="mb-4 h-1.5 w-14 rounded-full bg-emerald-500/70" data-testid={`${testIdPrefix}-accent`} />
      <p
        className="text-xs font-semibold uppercase tracking-[0.18em] text-stone-500"
        data-testid={`${testIdPrefix}-label`}
      >
        Key Takeaway
      </p>
      <div className="mt-4 max-w-4xl space-y-4 text-base leading-8 text-stone-700" data-testid={`${testIdPrefix}-content`}>
        {paragraphs.map((paragraph, index) => (
          <p key={`${testIdPrefix}-${index + 1}`} data-testid={`${testIdPrefix}-paragraph-${index + 1}`}>
            {paragraph}
          </p>
        ))}
      </div>
    </section>
  );
};